import { QuantitySelectorComponent } from '@theme/component-quantity-selector';

/**
 * Cart quantity selector.
 *
 * Fabric products retain Shopify's integer quantity internally:
 * 27 units = 2.7 metres.
 *
 * @extends {QuantitySelectorComponent}
 */
export class CartQuantitySelectorComponent extends QuantitySelectorComponent {
  connectedCallback() {
    super.connectedCallback();
    this.updateFabricDisplay();
  }

  /**
   * Cart uses the absolute variant maximum.
   *
   * @returns {number | null}
   */
  getEffectiveMax() {
    const { max } = this.getCurrentValues();
    return max;
  }

  updateButtonStates() {
    const { minusButton, plusButton } = this.refs;
    const { min, value } = this.getCurrentValues();
    const effectiveMax = this.getEffectiveMax();

    minusButton.disabled = value <= min;
    plusButton.disabled =
      effectiveMax !== null && value >= effectiveMax;
  }

  /**
   * Keep the visible metre amount synchronised with
   * Shopify's native integer quantity.
   */
  updateFabricDisplay() {
    if (this.dataset.fabricCart !== 'true') {
      return;
    }

    const display = this.querySelector(
      '[data-fabric-quantity-display]'
    );

    if (!display) {
      return;
    }

    const units =
      Number.parseInt(this.refs.quantityInput.value, 10) || 0;

    display.textContent = `${(units / 10).toFixed(1)} m`;
  }

  updateQuantity(stepMultiplier) {
    super.updateQuantity(stepMultiplier);
    this.updateFabricDisplay();
  }

  setQuantity(event) {
    super.setQuantity(event);
    this.updateFabricDisplay();
  }

  updateCartQuantity() {
    super.updateCartQuantity();
    this.updateFabricDisplay();
  }

  setValue(value) {
    super.setValue(value);
    this.updateFabricDisplay();
  }
}

if (!customElements.get('cart-quantity-selector-component')) {
  customElements.define(
    'cart-quantity-selector-component',
    CartQuantitySelectorComponent
  );
}